import React from 'react';
import '../HomePage/homepage.css';
import Navbar from './Navbar/Navbar';
import CarouselBanner from './Carousel/CarouselBanner';
import aboutus from '../../../../src/images/company-2.png';
import ThumbnailSlider from './Slider/ThumbnailSlider';
import ProductCards from './ProductCards/ProductCards';
// import Testimonial from './Testimonial/Testimonial';
import HomeFooter from './Footer/Footer';
import ScrollToTopButton from '../../ScrollButton';
import { Link } from 'react-router-dom';

function HomePage() {
    return (
        <>
            <Navbar />
            <CarouselBanner />
            <section className='container'>

                <div className="section">
                    <div className='row aboutus-section'>
                        <div className='col-sm-12 col-md-6 order-2 order-md-1'>
                            <div className='aboutus-img-wrapper'>
                                <img className='aboutus img-fluid' src={aboutus} alt="company" />
                                <div className="overlay">
                                    <h1 className="big-text">40</h1>
                                    <p className="small-text">Years<br /> Experience</p>
                                </div>
                            </div>
                        </div>

                        <div className='col-sm-12 col-md-6 aboutus-content order-1 order-md-2'>
                            <h2 className='heading'>Acoustical Surfaces Industries</h2>
                            <p className='aboutus-sub'>be the specialists of<br /> soundproofing and noise control</p>
                            <p>Acoustical Surfaces has been delivering reliable acoustic solutions for soundproofing, noise control, and vibration issues for over 40 years. With a wide range of over 400 specialty products, we provide effective solutions for residential, commercial, and industrial applications.<br />

                                Our offerings include soundproofing materials, acoustic panels, and vibration control systems designed to improve sound quality and reduce noise levels. We work across various sectors such as offices, studios, auditoriums, and manufacturing units.<br />

                                Our experienced specialists analyze your requirements and recommend customized solutions to achieve the best acoustic performance. We offer both onsite and remote consultations for your convenience.<br />

                                Call +91-82773 31000, +91-80257 22022, +91-94497 77212 to connect with our experts.<br />

                                Our team is available Monday to Saturday, from 9 AM to 6 PM.</p>
                        </div>
                    </div>
                </div>

                <div className='section col-sm-12'>
                    <h2 className='heading'>Our Works</h2>
                    <ThumbnailSlider />
                </div>

                <div className='section'>
                    <h2 className='heading'>Our Products</h2>
                    <ProductCards />
                </div>
                <div className='section'>
                    <div className="heading-right">
                        <h2 className='heading'>View more</h2>
                    </div>
                    <div className='viewmore mt-5'>
                        <div className='viewmore-content'>
                            <h1>Supply and Installation of Acoustic Panels</h1>
                            <p>Acoustical Surfaces offers everything you need for Commercial, Industrial, Educational, House of Worship, Pro Audio, OEM, Home Theater and other Residential applications.</p>
                            <p>For noise control applications Echo Eliminator™ is recommended.</p>
                            <p>Echo Eliminator™ is a high performance noise control product made from recycled cotton. For soundproofing ceilings, Sound Silencer™ is a great option. This dual function acoustical paneling blocks and absorbs sound. If you're going after the "recording studio" look, we offer a full line of acoustic foam.</p>
                            <Link to="/echo-eliminator"><button className="viewmore-btn">Explore Echo Eliminator™</button></Link>
                        </div>
                    </div>
                </div>

            </section >

            {/* <div className='testimonial'>
                <Testimonial />
            </div> */}

            <HomeFooter />
            <ScrollToTopButton />
        </>
    )
}

export default HomePage